// import _ from 'lodash';
import { GET_CANDIDATE } from '../actions/types';

const candidateReducer = (state={}, action) => {
    switch (action.type) {
        case GET_CANDIDATE:
            return  {...state, ...action.payload.data};

        // case GET_CANDIDATES:
        //     return { ...state, ..._.mapKeys(action.payload.data, 'registrationNumber') };
        // case GET_CANDIDATE:
        //     //[action.payload.id]- key interpolation. specifies a key based on d new object we're spreading
        //     return { ...state, [action.payload.registrationNumber]: action.payload };
        // case CREATE_CANDIDATE:
        //     return { ...state, [action.payload.registrationNumber]: action.payload };
        // case GET_DCANDIDATE: 
        //     return  action.payload
        // case EDIT_CANDIDATE:
        //     return { ...state, [action.payload.registrationNumber]: action.payload };
        // case DELETE_CANDIDATE:
        //     //for delete action creator, our payload was d ID of d stream we deleting. omit() creates a new object of our state exclusive of object with d specified key
        //     return _.omit(state, action.payload);
        default:
            return state;
    }
};

export default candidateReducer;